import { useState } from 'react'
import { BreadcrumbType, TonalitaDetailObject } from '@gql/graphql'
import { Breadcrumbs, ButtonRounded, Modal, WContainer, WImage } from '@components/atoms'
import { Close, Search } from '@components/icons'
import { HeaderBrand } from '@components/molecules'
import { BrandType } from '@components/molecules/HeaderBrand/HeaderBrand'
import { ZoomImage } from '@components/organisms'
import styles from './HeroTonalita.module.sass'
import useTrans from '@hooks/useTrans'

interface Props {
  tonalita: TonalitaDetailObject
  className?: string
}

const HeroTonalita = (props: Props) => {
  const { tonalita, className = '' } = props
  const [open, setOpen] = useState(false)
  const t = useTrans()

  return tonalita ? (
    <>
      <div className={`${styles.root} ${className}`}>
        <div className={styles.background} />
        <HeaderBrand brand={tonalita.brand.slug as BrandType} />
        <WContainer className={styles.container}>
          <Breadcrumbs
            className={styles.breadcrumbs}
            breadcrumbs={tonalita.tonalitaCollezione?.breadcrumbs}
          />
          <div className={styles.content}>
            {tonalita?.tonalitaCollezione?.tonalitaNome && (
              <h1 className={styles.title}>
                {tonalita?.collezione?.title && (
                  <div className={styles.description}>
                    {t('Collezione')} <span>{tonalita.collezione.title} </span>
                  </div>
                )}
                {tonalita.tonalitaCollezione.tonalitaNome}
              </h1>
            )}
          </div>
          {tonalita.tonalitaCollezione.articolo.image && (
            <div className={styles.imageBox}>
              <WImage
                className={styles.image}
                maxHeight={600}
                maxWidth={1240}
                src={tonalita.tonalitaCollezione.articolo.image}
                alt={tonalita.tonalitaCollezione.articolo?.imageAlt}
                priority
                loading="eager"
              />
              <ButtonRounded
                className={styles.searchIcon}
                icon={<Search />}
                onClick={() => setOpen(true)}
              />
            </div>
          )}
        </WContainer>
      </div>

      <Modal
        className={styles.modal}
        open={open}
        onClose={() => setOpen(false)}
        id="modal-tonalita"
        closeButton={true}
        closeClassName={styles.closeIconModal}
      >
        <WContainer className={styles.modalContainer}>
          <div className={styles.modalImageBox}>
            <ZoomImage
              className={styles.modalImage}
              image={{
                url: tonalita.tonalitaCollezione.articolo.image,
              }}
            />
            <ButtonRounded
              icon={<Close />}
              className={styles.closeIcon}
              onClick={() => setOpen(false)}
            />
          </div>
        </WContainer>
      </Modal>
    </>
  ) : (
    <></>
  )
}

export default HeroTonalita
